import FormCompose from './form-compose';

export default class QaCompose extends FormCompose
{
    constructor()
    {
        // call FormCompose constructor
        super();

        // change the production/calibration form toggle
        $('#calibration').on('change', (e) => {
            this.changeCalibrationToggle(e);
        });
    }

    /**
     * changeCalibrationToggle
     * 
     * Update the label when you change the production/calibration toggle.
     * 
     * @param {Object} event
     * @return null
     */
    changeCalibrationToggle(event)
    {
        let toggle = $(event.currentTarget)[0];

        if (toggle.checked) {
            $('#calibration').prev().text('Calibration');
        } else {
            $('#calibration').prev().text('Production');
        }
    }
}
